export type NativeAuthMode = 'sign-in' | 'sign-up' | 'reset';

export function getCurrentAuthReturnTo(fallback = '/user'): string {
  if (typeof window === 'undefined') return fallback;
  const { pathname, search, hash } = window.location;
  const current = `${pathname || '/'}${search || ''}${hash || ''}`;
  if (!current || current.startsWith('/auth')) return fallback;
  return current;
}

export function sanitizeAuthReturnTo(value: string | null | undefined, fallback = '/user'): string {
  const raw = String(value || '').trim();
  if (!raw) return fallback;
  if (raw.startsWith('/') && !raw.startsWith('//')) return raw;
  try {
    const url = new URL(raw);
    if (typeof window !== 'undefined' && url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    // ignore invalid URLs
  }
  return fallback;
}

export function createAuthPath(
  mode: NativeAuthMode = 'sign-in',
  returnTo?: string | null,
  params: Record<string, string | null | undefined> = {},
): string {
  const search = new URLSearchParams();
  search.set('mode', mode);
  const next = sanitizeAuthReturnTo(returnTo, '/user');
  if (next) search.set('returnTo', next);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && String(value).trim()) {
      search.set(key, String(value));
    }
  });
  return `/auth?${search.toString()}`;
}
